<template>
  <div class="addaccountBox">
    <el-form ref="fromData" :model="form" :rules="rules" label-width="120px">
      <el-form-item v-if="isEdit" label="账号" prop="name">
        {{account}}
      </el-form-item>
      <el-form-item v-if="isEnterprise" label="服务商" prop="customerIds">
        <Carrier
          ref="serviceSelect"
          :value="form.customerIds"
          :only-select="false"
          @change="handleChange"
        />
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" :disabled="isEdit"></el-input>
      </el-form-item>
      <el-form-item label="手机号"
        prop="phone"
      >
       <el-input v-model.number="form.phone" maxlength="11"  :disabled="isEdit"></el-input>
      </el-form-item>
      <el-form-item v-if="false" label="组织及项目范围">
        <div class="treeBox">
          <el-radio v-model="form.orgMaintainMode" :label="1" @change="radioChange">
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-end"
            >
              <div slot="content" class="tipsBox">{{TEXT_ORG}}</div>
              <span class="itemBox">
                <span>按组织维护</span>
                <i class="el-icon-question tipsimg"></i>
              </span>
            </el-tooltip>
          </el-radio>
          <el-radio v-model="form.orgMaintainMode" :label="2" @change="radioChange">
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-end"
            >
              <div slot="content" class="tipsBox">{{TEXT_ALL}}</div>
              <span class="itemBox">
                <span>按组织及项目维护</span>
                <i class="el-icon-question tipsimg"></i>
              </span>
            </el-tooltip>
          </el-radio>
          <el-input
            v-model="filterText"
            placeholder="输入关键字进行过滤">
          </el-input>
          <div v-if="form.orgMaintainMode === 1" class="orgBox">
            <el-tree
              ref="tree"
              :props="defaultProps"
              :data="treeData"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="defaultKeys"
              :filter-node-method="filterNode"
              check-strictly
              >
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span>{{ node.label.name }}</span>
                  <span v-if="data.childrenOrg && data.childrenOrg.length > 0" class="nodeStyle" @click.stop="checkeChildren(data)">
                    选择所有下级节点
                    </span>
                </span>
            </el-tree>
          </div>
          <div v-if="form.orgMaintainMode === 2" class="orgProjectBox">
            <el-tree
              ref="tree"
              :props="defaultProps"
              :data="treeData"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="defaultKeys"
              :filter-node-method="filterNode"
              check-strictly
              @check="checkNode"
              >
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span v-if="node.label.type === 'PROJECT'" class="labelStyle">项目</span>
                  <span>{{ node.label.name }}</span>
                  <span v-if="data.childrenOrg && data.childrenOrg.length > 0" class="nodeStyle" @click.stop="checkeChildren(data)">
                    选择所有下级节点
                    </span>
                </span>
            </el-tree>
          </div>
        </div>
      </el-form-item>
      <el-form-item>

      </el-form-item>
      <el-form-item label="功能权限">
        <el-radio v-model="form.functionMaintainMode" :label="1">
          <el-tooltip
            class="item"
            effect="dark"
            placement="top-end"
          >
          <div slot="content" class="tipsBox">{{AUTHOR_ALL}}</div>
            <span class="itemBox">
              <span>全部权限</span>
              <i class="el-icon-question tipsimg"></i>
            </span>
          </el-tooltip>
        </el-radio>
        <el-radio v-model="form.functionMaintainMode" :label="2">部分权限</el-radio>
      </el-form-item>
      <el-form-item v-if="form.functionMaintainMode === 2">
        <div>
          <el-tree
            ref="func"
            :props="funcDefaultProps"
            :data="funcTreeData"
            show-checkbox
            node-key="id"
            default-expand-all
            :default-checked-keys="defaultFuncKey"
            >
          </el-tree>
        </div>
      </el-form-item>
    </el-form>
    <fix-boottom>
      <template slot="button">
        <a-button class="close" @click="onCancel">
        取消
        </a-button>
        <a-button type="primary" @click="submitSetting('fromData')">
          {{isEdit ? '保存' : '提交'}}
        </a-button>
      </template>
    </fix-boottom>
  </div>
</template>

<script>
import {uniqueArray} from '@/utils/util'
import {fetchProject} from '@/pages/orderManage/api'
import Carrier from './components/Carrier.vue'
import FixBoottom from './components/FixBottom'
import { getUserFunctionTree, getAccountIdentity, addAccounts, verificationAccount, organizationCorpTree, organizationTree } from './api'

const TEXT_ALL = '仅勾选的组织和项目有权限，当项目新增时需要手动配置才能获取新项目权限'
const TEXT_ORG = '勾选的组织具有组织下全部项目权限，当项目增加时无需配置自动获取权限'
const AUTHOR_ALL = '具有货主版所有菜单及按钮权限，当菜单或按钮增加时无需配置自动获取权限'

export default {
  name: "AddAccount",
  components: {
    FixBoottom,
    Carrier,
  },
  props: {},
  data() {
    return {
      TEXT_ALL,
      TEXT_ORG,
      AUTHOR_ALL,
      checked: false,
      form: {
        name: '',
        phone: '',
        porject: '',
        orgMaintainMode: 1,
        functionMaintainMode: 1,
        customerIds: []
      },
      count: 1,
      filterText: '',
      defaultProps: {
        children: 'childrenOrg',
        label: 'current'
      },
      funcDefaultProps: {
        children: 'children',
        label: 'name'
      },
      treeData: [
      ],
      funcTreeData: [],
      defaultKeys: [],
      rules: {
        customerIds: [
          { required: true, message: '请选择承运商', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          { max: 30, message: '不超过30个字符', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { min: 10000000000, type: 'number', message: '仅支持数字,长度必须为11个字符',trigger: 'change'}
        ],
      },
      orgIds: [],
      defaultFuncKey: [],
      accountId: null,
      account: null,
      isEdit: false,
      accountData: {},
      isEnterprise: false,
      editeCustomers: [],
    };
  },
  computed: {},
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
  async created() {
    const itemData = this.$route.query
    const {admin,userId,creditCode,customers}=this.$store.state.user
    this.isEnterprise = !!creditCode
    if(!creditCode||customers.length===1){
      this.accountData = JSON.parse(localStorage.getItem('accountData'));
      this.orgIds = [this.accountData.id]
    }
    this.customer =admin
    await this.getUserFunctionTree(userId, itemData)
    // 获取组织树
      this.organizationTree('ORG')
    // 修改
    if(itemData.realName){
      this.init(itemData)
    }
  },
  mounted() {
  },
  methods: {
    handleChange(value) {
      this.form.customerIds = value.map(item => item.id)
      const {customers = []} = this.$store.state.user
      const orgList = customers.filter(item => this.form.customerIds.includes(item.customerId))
      this.orgIds = orgList.map(item => item.orgId || '')
    },
    checkeChildren(data){
      this.$refs.tree.setChecked(data.id, true, false)
      if(data.childrenOrg && data.childrenOrg.length > 0){
        data.childrenOrg.forEach((e) => {
          this.checkeChildren(e)
        })
      }
    },
    checkNode(renode, ednode) {
      if(renode.current.type === 'PROJECT'){
        // 选择项目联动选择上级组织
        if(ednode.checkedKeys.includes(renode.id)){
          this.$refs.tree.setChecked(renode.parentId, true, false)
        }
      } else if(!ednode.checkedKeys.includes(renode.id)){
        const childrenData = this.$refs.tree.getNode(renode.id)
        childrenData.childNodes.forEach((e) => {
          this.$refs.tree.setChecked(e.data.id, false, false)
        })
      }
    },
    async organizationTree( orgType){
      const {userId,creditCode,customers=[],customerCode, customerId}=this.$store.state.user
      const data = {
        accountId: userId,
        orgType,
        objId: customerId,
        accountType: 'CUSTOMER',
        needChildren:true,
        relationType: 'DOWN',
        orgStatus: 'ENABLED',
        source: 'OWN',
        status: 'ENABLE'
      }
      if(!creditCode||customers.length===1){
        data.relationOrgId = this.accountData.id;
        if (orgType) {
          const res = await organizationTree(data)
          this.treeData = this.mapData(res)
        } else {
          const resData = await fetchProject({
            ...data,
            customerCode: customers[0]&&customers[0].customerCode?customers[0].customerCode:customerCode,
            source: 'OWN',
            status: 'ENABLE'
          })
          const records = uniqueArray(resData,'id');
          if (records && records.length > 0) {
            const res = [{
              id: records[0].parentOrgId,
              parentId: 0,
              current: {
                ...records[0],
                id:records[0].parentOrgId,
                name: records[0].customerName,
                code:records[0].customerCode,
              },
              childrenOrg: records.map(t => ({
                ...t,
                id: t.id,
                parentId: records[0].parentOrgId,
                current: {
                  name: t.projectName,
                  code: t.projectCode,
                  type: "PROJECT",
                  id:t.id,
                }
              }))
            }]
            this.treeData = this.mapData(res)
          }else{
            this.treeData = [];
          }
        }
      }else{
        data.creditCode=creditCode
        const res= await organizationCorpTree(data)
        res[0].id=res[0].current.code
        this.treeData = this.mapData([{
          ...res[0],
          id: res[0].id=res[0].current.code
        }])

      }
    },
    mapData(res) {
      const {creditCode}=this.$store.state.user
      return res.map((e) => {
        if(e.id === creditCode){
          this.defaultKeys.push(e.id)
          return {
            ...e,
            disabled: true
          }
        }
        if(e.id === this.accountData.id){
          this.defaultKeys.push(e.id)
          return {
            ...e,
            disabled: true
          }
        }
        if(e.childrenOrg && e.childrenOrg.length > 0){
          return {
            ...e,
            childrenOrg: this.mapData(e.childrenOrg)
          }
        }
        return {
          ...e
        }
      })
    },
    init(itemData){
      this.isEdit = true;
      this.form.name = itemData.realName
      this.form.phone = itemData.mobile * 1
      this.accountId = itemData.accountId
      this.account = itemData.account
      const customers = JSON.parse(itemData.customers || '[]')
      this.form.customerIds = customers.map(item => item.id)
      this.editeCustomers = [...this.form.customerIds]
      this.orgIds = customers.map(item => item.orgId)
      this.defaultFuncKey = []
      const {customerId} = this.$store.state.user
      getUserFunctionTree({
        accountId: itemData.accountId,
        objId: customerId,
        admin: false,
        systemCode: 'customer',
        functionTypes: ['MODULE', 'MENU', 'BUTTON'],
        status: 'ENABLED',
        objIds: this.form.customerIds
      }).then((res)=>{
        if(res && res.length > 0){
              this.form.functionMaintainMode = 2
          setTimeout(()=>{
            this.filterFuncKey(res)
          }, 300)
        }
      })
      // 获取账号绑定的组织
      // organizationList({
      //   accountId: itemData.accountId,
      //   // accountType: 'CUSTOMER',
      //   // relationType: 'DOWN',
      //   // needAccountOrg: true,
      //   // relationOrgId:itemData.orgId
      // }).then(async (res) => {
      //   // const { orgMaintainMode } = this.$route.query;
      //   // const type=Number(orgMaintainMode)===2?2:1
      //   // const orgType = type=== 1 ? "ORG" : null
      //   // this.form.orgMaintainMode = type;
      //   // await this.organizationTree(orgType)
      //   // this.filterAccountKey(res)
      // })
      // 获取绑定账号的身份
      getAccountIdentity({
        accountId: itemData.accountId,
        identityId: this.accountData.identityId
      }).then(() => {})
    },
    filterAccountKey(res){
      res.forEach((e) => {
        this.$refs.tree.setChecked(e.id, true, false)
      })
    },
    filterFuncKey(res){
      res.forEach((e) => {
        this.$refs.func.setChecked(e.id, true, false)
        if(e.children.length > 0){
          this.filterFuncKey(e.children)
        }
      })
    },
    async getUserFunctionTree(accountId, itemData){
      const customers = JSON.parse(itemData.customers || '[]')
      const {customerId} = this.$store.state.user
      this.funcTreeData = await getUserFunctionTree({
        accountId,
        objId: customerId,
        admin: this.customer,
        systemCode: 'customer',
        functionTypes: ['MODULE', 'MENU', 'BUTTON'],
        status: 'ENABLED',
        objIds: customers.map(item => item.id)
      })
    },
    radioChange(){
      if(this.form.orgMaintainMode === 1){
        this.organizationTree('ORG')
      } else {
        this.organizationTree(null)
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.current.name.indexOf(value) !== -1;
    },
    onCancel() {
      this.$router.go(-1)
    },
    submitSetting(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let nddesFuncData = null
          let nodesHalfFuncData = null
          if(this.form.functionMaintainMode === 2){
            nddesFuncData = this.$refs.func.getCheckedKeys()
            nodesHalfFuncData = this.$refs.func.getHalfCheckedKeys()

            if(nddesFuncData.length <= 0){
              return this.$message.warning('请选择账号权限')
            }
            if(nodesHalfFuncData.length > 0){
              nddesFuncData.push(...nodesHalfFuncData)
            }
          }
          // const nodesData = this.$refs.tree.getCheckedKeys()
          // if(nodesData.length <= 0){
          //   return this.$message.warning('请选择组织或项目')
          // }
          if (this.isEdit) {
            // return this.onSubmit(nodesData, nddesFuncData)
            return this.onSubmit( nddesFuncData)
          }

          // 根据手机号验证账号是否存在
          verificationAccount({
            mobile: this.form.phone
          }).then((res) => {
            if(res && res.length !== 0){
              this.$confirm({
                content: `手机号对应的账号已存在，对应姓名[${res[0].realName}]，确定将该账号绑定到选中的货主/项目？`,
                okText: '确定',
                okType: 'primary',
                cancelText: '取消',
                onOk: async () => {
                  // this.onSubmit(nodesData, nddesFuncData)
                  this.onSubmit(nddesFuncData)
                },
              })
            } else {
              // this.onSubmit(nodesData, nddesFuncData)
              this.onSubmit(nddesFuncData)
            }
          })
        }
        return false;
      });
    },

    onSubmit(nddesFuncData){
      const { customerId } = this.$store.state.user;
      // const checkNodes = this.$refs.tree.getCheckedNodes();
      // const projectIds = checkNodes.filter(t => t.current.type === "PROJECT").map(t => t.current.id);
      // // const {customerId,creditCode,customers} = this.$store.state.user;
      // if(this.form.orgMaintainMode===2&&!projectIds.length){
      //   this.$message.warning('请至少选择一个项目')
      //   return 
      // }
      const data = {
        realName: this.form.name,
        customerId,
        customerIds: this.isEnterprise ? this.form.customerIds : null,
        mobile: this.form.phone,
        // orgMaintainMode: this.form.orgMaintainMode,
        orgIds: this.orgIds,
        functionMaintainMode: this.form.functionMaintainMode,
        functionIds: nddesFuncData,
        accountId: this.accountId,
        channel: 'WEB_CREATE',
        // projectIds,
        editCustomerAccount:true
      }
      if(this.isEnterprise && this.isEdit) {
        const deletedCustomerIds = [];
        this.editeCustomers.forEach(item => {
          if (!this.form.customerIds.includes(item)) {
            deletedCustomerIds.push(item)
          }
        })
        data.deletedCustomerIds = deletedCustomerIds
      }
      // if(creditCode){
      //   const customerIds=[]
      //   nodesData.forEach(item=>{
      //     customers.forEach(child=>{
      //       if(child.orgId===item){
      //         customerIds.push(child.customerId)
      //       }
      //     })
      //   })
      //   data.customerIds=customerIds
      // }else{
      //   data.customerId=customerId
      // }
      addAccounts(data).then(() => {
        this.$message.success('保存成功')
        this.$router.go(-1)
      })
    },
    checkeDom(data) {
      this.$refs.tree.setChecked(data.current.id, true, false)
    }
  },
};
</script>

<style lang="less" scoped>
.addaccountBox{
    background: #fff;
    padding: 30px 30px 15px;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
}
.el-form{
  width: 50%;
}
.tipsimg{
  width: 16px;
  height: 16px;
  color: #8d8d8e;
  position: absolute;
  top: -10px;
  right: -10px;
}
.tipsBox{
  width: 150px;
}
.labelStyle{
  display: inline-block;
  font-size: 12px;
  line-height: 16px;
  border: 1px solid red;
  color: red;
  padding: 3px;
  border-radius: 3px;
  margin-right: 5px;
  transform: scale(0.8);
}
.treeBox{
  border: 1px solid #ccc;
  padding: 20px;
  box-sizing: border-box;
  max-height: 500px;
  overflow-y: scroll;
}
/deep/ .custom-tree-node{
  width: 100%;
}
.nodeStyle{
  float: right;
  margin-right: 20px;
  color: #25c48d;
  font-size: 12px;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #25c48d;
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #25c48d;
  background: #25c48d;
}
/deep/ .el-radio__inner:hover{
  border-color: #25c48d;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #25c48d;
  border-color: #25c48d;
}
/deep/ .el-checkbox__inner:hover{
  border-color: #25c48d;
}
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #25c48d;
  border-color: #25c48d;
}
/deep/ .treeBox{
  .el-input__inner{
    height: 30px;
    width: 50%;
    margin-bottom: 20px;
  }
}
</style>
